import './App.css';
import Dictionary from "./Dictionary";

function App() {
  return (
    <div className="App">
      <header><a href="https://github.com/TheSmilycake/dictionary-search">GitHub</a> • Made by Rebecca Wiedau</header>
      <h1>Dictionary App</h1>
        <Dictionary/>
    </div>
  );
}

export default App;
